/* eslint-disable @typescript-eslint/no-non-null-assertion */
import axios, { AxiosError, AxiosRequestConfig } from 'axios'

import { API_CONFIG, getEnv } from '../config/api'
import { ApiResponse, ErrorData } from '../interfaces'

const env = getEnv()

const {
  sendTo: { url: sendToURL, token },
} = API_CONFIG[env]

const sendToLoginFallbackMiddleware = async (
  userId: string,
  middleware: AxiosRequestConfig
): Promise<ApiResponse<string | ErrorData>> => {
  const payload = {
    userId,
  }

  try {
    const { status } = await axios({
      ...middleware,
      data: payload,
    })

    return {
      data: 'redirect successful',
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const sendToLoginFallbackBSNG = async (userId: string): Promise<ApiResponse<string | ErrorData>> => {
  try {
    const { status } = await axios.post(
      sendToURL,
      { userId },
      {
        headers: {
          'x-api-key': token,
        },
      }
    )

    return {
      data: 'redirect successful',
      status,
      success: true,
    }
  } catch (err) {
    const { response } = err as AxiosError<ErrorData>
    const { data, status } = response!

    return {
      data,
      status,
      success: false,
    }
  }
}

const sendToLoginFallback = async (
  userId: string,
  middleware?: AxiosRequestConfig
): Promise<ApiResponse<string | ErrorData>> => {
  let response

  if (middleware) {
    response = await sendToLoginFallbackMiddleware(userId, middleware)
  } else {
    response = await sendToLoginFallbackBSNG(userId)
  }

  return response
}

export default sendToLoginFallback
